import easyModal from './easyModal.json';
import empty from './empty.json';
import paginator from './paginator.json';
import menuBar from './menuBar.json';
import breadcrumbs from './breadcrumbs.json';
export default { easyModal, empty, paginator, breadcrumbs, menuBar };
